function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
var IntervalTimer = function (_React$Component) {
  _inherits(IntervalTimer, _React$Component);
  function IntervalTimer(props) {
    _classCallCheck(this, IntervalTimer);
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
    _this.initializeInterval = function (callback, timeout) {
      _this.resetTimeout();
      _this.resetInterval();
      _this.interval = setInterval(callback, timeout);
    };
    _this.initializeTimeout = function (callback, timeout) {
      _this.resetTimeout();
      _this.resetInterval();
      _this.timeout = setTimeout(callback, timeout);
    };
    _this.resetInterval = function () {
      if (_this.interval) {
        clearInterval(_this.interval);
      }
    };
    _this.resetTimeout = function () {
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }
    };
    return _this;
  }
  IntervalTimer.prototype.componentDidMount = function componentDidMount() {
    if (this.props.enabled) {
      if (this.props.repeat) {
        this.initializeInterval(this.props.callback, this.props.timeout);
      } else {
        this.initializeTimeout(this.props.callback, this.props.timeout);
      }
    }
  };
  IntervalTimer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.enabled) {
      this.resetInterval();
      this.resetTimeout();
    } else {
      if (this.props.enabled !== nextProps.enabled || this.props.repeat !== nextProps.repeat || this.props.timeout !== nextProps.timeout || this.props.callback !== nextProps.callback) {
        if (nextProps.repeat) {
          this.initializeInterval(nextProps.callback, nextProps.timeout);
        } else {
          this.initializeTimeout(nextProps.callback, nextProps.timeout);
        }
      }
    }
  };
  IntervalTimer.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  };
  IntervalTimer.prototype.render = function render() {
    return null;
  };
  return IntervalTimer;
}(React.Component);
IntervalTimer.propTypes = process.env.NODE_ENV !== "production" ? {
  timeout: PropTypes.number,
  enabled: PropTypes.bool,
  callback: PropTypes.func,
  repeat: PropTypes.bool
} : {};
IntervalTimer.defaultProps = {
  timeout: 1000,
  enabled: false,
  callback: function callback() {
    console.log("You need to set your callback function for IntervalTimer");
  },
  repeat: true
};
export default IntervalTimer;